import { RouteConfig } from 'vue-router';
const CreateTempalte = () => import('../template/views/create-template.vue');
const routers: RouteConfig[] = [
    {
        path: '',
        redirect: 'create-tempalte',
    },
    {
        path: 'create-tempalte',
        name: 'create-tempalte',
        component: CreateTempalte,
    },
];
export default routers;

